export default __webpack_public_path__ + "8e9ba9da4897c6f376c45543954f6973.png";